export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_9.3a30c38f.png";